<span class="title">ENTREGADOS</span>
<div class="container">
  <app-order-delivered-card
    *ngFor="let order of orders$ | async"
    [order]="order"
    (undeliver)="undeliver(order)"
  ></app-order-delivered-card>
</div>
<div class="btn" [routerLink]="['/to-delivery']">IR A ACTUALES</div>
